import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { HeroHome } from '../components/home/HeroHome';
import { ProblemSolutionHome } from '../components/home/ProblemSolutionHome';
import { AboutMeHome } from '../components/home/AboutMeHome';
import { AriseMethod } from '../components/AriseMethod';
import { WorkWithMe } from '../components/WorkWithMe';
import { FreeResourcesHome } from '../components/home/FreeResourcesHome';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <>
      <SharedNavbar data-id="element-942" />
      <main className="flex-grow" data-id="element-943">
        <HeroHome data-id="element-944" />
        <ProblemSolutionHome data-id="element-945" />
        <AboutMeHome data-id="element-946" />
        <AriseMethod data-id="element-947" />
        <WorkWithMe data-id="element-948" />
        <FreeResourcesHome data-id="element-949" />
        <FinalCTA data-id="element-950" />
      </main>
      <Footer data-id="element-951" />
    </>;
}